import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './components/App';
import { BrowserRouter } from 'react-router-dom';

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDbzvswLScq_Xce9tQsRNpLSDjDH3hJrec",
  authDomain: "gyl2-c5a5b.firebaseapp.com",
  projectId: "gyl2-c5a5b",
  storageBucket: "gyl2-c5a5b.appspot.com",
  messagingSenderId: "957444903658",
  appId: "1:957444903658:web:4a843f5cb13dbd99bb3d93",
  measurementId: "G-RDZF2YN5VF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

ReactDOM.render(
  <BrowserRouter>
      <App />
  </BrowserRouter>,
  document.getElementById('root')
);

// IF DATABSE IS NOT RUNNING, CHECK FIREBASE TO CHANGE REALTIME DATABASE SETTINGS